import React from 'react'

import { Link } from 'gatsby'

import { ProductsDropdownType } from '@contracts/wp/megaMenu'

import MegaMenuCards from './MegaMenuCards'
import MegaMenuItem from './MegaMenuItem'
import * as styles from './ProductsDropdown.module.scss'

import ArrowIcon from '@icons/arrow-right-controlled.svg'

type Props = {
	data: ProductsDropdownType
}

const ProductsDropdown: React.FC<Props> = ({ data }) => {
	const [isSubmenuOpen, setIsSubmenuOpen] = React.useState(false)

	const dropdownStyles = [styles.productsDropdown]
	const iconStyles = [styles.icon]

	if (isSubmenuOpen) {
		dropdownStyles.push(styles.isOpen)
		iconStyles.push(styles.isOpen)
	}

	const dropdownContentStyles = [styles.dropdownContent]

	if (!data.productCards || data.productCards.length == 0) {
		dropdownContentStyles.push(styles.noCards)
	}

	return (
		<ul className={dropdownStyles.join(' ')}>
			<li className={styles.dummyLink}>
				<MegaMenuItem data={{ link: { title: 'Products', uri: '/products' } }} className={styles.triggerLink} />

				<div className={styles.submenuWrapper}>
					<div className={styles.iconWrapper} onClick={() => setIsSubmenuOpen(!isSubmenuOpen)}>
						<ArrowIcon className={iconStyles.join(' ')} />
					</div>

					<div className={styles.dropdown}>
						<div className={dropdownContentStyles.join(' ')}>
							<div className={styles.submenu}>
								{/* Active Categories */}
								<ul className={styles.activeCategories}>
									{data.productCategories.activeCategories.map(
										({ category, categoryProducts }, i) => {
											return (
												<li key={i} className={styles.activeCategoryItem}>
													<Link to={category.uri} className={styles.categoryLink}>
														{category.name}
													</Link>
													<ul className={styles.productLinks}>
														{categoryProducts.map(({ product }, i) => {
															return (
																<li key={i} className={styles.productLinkItem}>
																	<Link
																		to={product.uri}
																		className={styles.productLink}
																	>
																		{product.title}
																	</Link>
																</li>
															)
														})}
													</ul>
												</li>
											)
										}
									)}
								</ul>

								{/* Other Categories */}
								<ul className={styles.otherCategories}>
									{data.productCategories.otherCategories.map(({ category }, i) => {
										if (category.name === 'Part-exchange') {
											category.uri = '/part-exchange/'
										}

										return (
											<li key={i} className={styles.otherCategoryItem}>
												<Link to={category.uri} className={styles.categoryLink}>
													{category.name}
												</Link>
											</li>
										)
									})}
								</ul>
							</div>

							{data.productCards && data.productCards.length > 0 ? (
								<MegaMenuCards data={data.productCards} className={styles.cards} />
							) : null}
						</div>
					</div>
				</div>
			</li>
		</ul>
	)
}

export default ProductsDropdown
